import { formatDate } from '@/package';
import type { APIKey } from '@/type';

export const makeAPIKeyDataForTable = (
  item: APIKey,
  isEditablePermission: boolean,
) => {
  return {
    id: item.id,
    keyName: item.name,
    status: item.status,
    usage: item.usage,
    secretKey: '************',
    lastAccessed: item.lastUseTimeAt ? formatDate(item.lastUseTimeAt) : '-',
    createdBy: item.user.email,
    expirationTime: formatDate(item.expireAt),
    activate:
      item.status === 'Enable'
        ? true
        : item.status === 'Disable'
          ? false
          : null,
    raw: {
      ...item,
      isEditablePermission,
    },
  };
};
